import React from 'react';
import { ArrowRight } from 'lucide-react';

export const UsEnquireButton = ({ onClick, testId, children = 'Discuss your US setup', secondary = false }) => (
  <button type="button" className={`uk-button ${secondary ? 'uk-button-outline' : ''}`} onClick={onClick} data-testid={testId}>
    {children}<ArrowRight size={17} aria-hidden="true" />
  </button>
);

export const UsSectionHeading = ({ number, eyebrow, title, text, id }) => (
  <div className="uk-section-heading" data-testid={`${id}-heading`}>
    <div className="uk-eyebrow"><span className="uk-eyebrow-num">{number}</span><span className="uk-rule" />{eyebrow}</div>
    <h2>{title}</h2>
    {text && <p>{text}</p>}
  </div>
);
